import script from "./D3DonutChart.vue?vue&type=script&setup=true&lang=js"
export * from "./D3DonutChart.vue?vue&type=script&setup=true&lang=js"

import "./D3DonutChart.vue?vue&type=style&index=0&id=44325da6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44325da6"]])

export default __exports__